export default __webpack_public_path__ + "images/3J.27b6cba.png";